import type { ReactNode } from 'react';
import { isFormula } from '../lib/formula';

/** A worked-out quantity for display: Indian grouping, no padded decimals. */
export const fmtQty = (n: number, digits = 2) => n.toLocaleString('en-IN', { maximumFractionDigits: digits });

/** Under a number field: what its formula came to, or why it can't be read. */
export function Worked({ text, value, unit = '', digits = 2 }: {
  text: string; value: number | null; unit?: string; digits?: number;
}) {
  if (value != null && Number.isNaN(value)) {
    return <div className="text-[11px] text-red-600 mt-0.5">Can't read this — use a number or =formula</div>;
  }
  if (value != null && value < 0) {
    return <div className="text-[11px] text-red-600 mt-0.5">Can't be negative</div>;
  }
  if (value != null && isFormula(text)) {
    return <div className="text-[11px] text-slate-500 mt-0.5">= {fmtQty(value, digits)}{unit}</div>;
  }
  return null;
}

/** A number field that also takes a formula ("=5.5*100"), showing its result. */
export function NumField({ label, text, onText, value, placeholder, unit, digits, autoFocus, disabled }: {
  label: ReactNode; text: string; onText: (s: string) => void;
  value: number | null; placeholder?: string; unit?: string; digits?: number; autoFocus?: boolean; disabled?: boolean;
}) {
  return (
    <div>
      <label className="label">{label}</label>
      <input className="input disabled:bg-slate-50 disabled:text-slate-500" inputMode="decimal" value={text}
        onChange={e => onText(e.target.value)} placeholder={placeholder} autoFocus={autoFocus} disabled={disabled} />
      <Worked text={text} value={value} unit={unit} digits={digits} />
    </div>
  );
}
